export default __webpack_public_path__ + "static/media/file-word.a4ee7697.svg";